import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"

import IOS_1 from "../../../resources/tutorial/DOOR_IOS_1.png"
import IOS_QR_Code from "../../../resources/tutorial/Apple_QRCode.png"

import ANDROID_1 from "../../../resources/tutorial/AndroidDownload_Step1.png"
import ANDROID_QR_Code from "../../../resources/tutorial/Android_QRCode.png"

import Button from "../../Button"

const AppDownloadInstructions: InstructionComponentProps = {
    name: "Wie lade ich die DOOR Studie Connect App herunter?",
    path: "/help/patient/download",
    description: "Bitte laden Sie die DOOR Studie Connect App aus dem App Store (für iOS) oder bei Google Play (für Android) herunter.",
    ios: {
        steps: [
            <ImageTextComponent
                text={
                    <>
                        Die App kann bequem im Apple App Store heruntergeladen werden. 
                    </>
                }button={
                    <><Button
                        onClick={() => window.open(
                            "https://apps.apple.com/de/app/door-studie-connect/id6741898497",
                            "_blank"
                        )}
                    >
                        Zur App im Store
                    </Button>
                    <img
                            src={IOS_QR_Code}
                            alt="QR‑Code zur DOOR Studie Connect‑App (iOS)"
                            style={{ marginTop: 8, width: "30vw", maxWidth: 150, height: "auto" }}/></>
                }
                images={[IOS_1]}
            />,
            <ImageTextComponent
                text={
                    <>
                       Einmal heruntergeladen, können Sie sich mit den Anmeldedaten, die Sie vom Studienteam erhalten werden, in der App einloggen. 
                       Die Anmeldedaten erhalten Sie vom Studienteam vor Ort in der Arztpraxis.
                    </>
                    }
                images={[]}
            />,
        ]
    },
    android: {
        steps: [
            <ImageTextComponent
                text={
                    <>
                        Die App kann bequem im Google Play Store heruntergeladen werden.
                    </>
                }button={
                    <><Button
                        onClick={() => window.open(
                            "https://play.google.com/store/apps/details?id=de.tum.cit.kl.doorconnect&hl=de",
                            "_blank"
                        )}
                    >
                        Zur App im Store
                    </Button><img
                            src={ANDROID_QR_Code}
                            alt="QR‑Code zur DOOR Studie Connect‑App (Android)"
                            style={{ marginTop: 8, width: "30vw", maxWidth: 150, height: "auto" }} /></>
                }
                images={[ANDROID_1]}
            />,
            <ImageTextComponent
                text={
                    <>
                       Einmal heruntergeladen, können Sie sich mit den Anmeldedaten, die Sie vom Studienteam erhalten werden, in der App einloggen. 
                       Die Anmeldedaten erhalten Sie vom Studienteam vor Ort in der Arztpraxis.
                    </>
                }
                images={[]}
            />
        ]
    }
}

export default AppDownloadInstructions
